import React from "react";
import styled from "styled-components";
import moment from "moment";
import baseStyles from "../../styles/baseStyles";
import Startup from "../../assets/icons/startup.svg";

const Card = styled.div`
  box-shadow: ${({ active }) =>
    active ? baseStyles.layers.l5 : baseStyles.layers.l3};
  border-radius: 3px;
  background-color: ${baseStyles.color.white.o100};
  padding: 1rem;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  transition: 0.2s 0.05s all ease-in-out;
  transform: ${props => (props.active ? "scale(1.03)" : "none")};
  :not(:last-of-type) {
    margin-bottom: 1.5rem;
  }
  :hover {
    box-shadow: ${({ active }) =>
      active ? baseStyles.layers.l5 : baseStyles.layers.l4};
  }
`;
const JobTitle = styled.h4`
  font-family: Lato;
  font-size: 15px;
  color: ${baseStyles.color.darkGray};
  letter-spacing: 1.41px;
  margin: 0;
  margin-bottom: 0.5rem;
  font-weight: 400;
`;

const Logo = styled.img`
  height: 4rem;
  width: 4rem;
  border-radius: 50%;
`;

const Subheading = styled.span`
  font-family: Lato;
  font-size: 14px;
  color: ${baseStyles.color.lightGray};
  letter-spacing: 1.2px;
  font-weight: 300;
  margin-bottom: 0.25rem;
`;

const LeftColumn = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  margin-right: 1rem;
`;

const RightColumn = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  flex-direction: column;
  text-align: right;
  @media screen and (max-width: 48em) {
    text-align: left;
    align-items: flex-start;
    margin-top: 2rem;
  }
`;

const DefaultContent = styled.a`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  align-items: flex-start;
  text-decoration: none;
  @media screen and (max-width: 48em) {
    flex-direction: column;
    justify-content: flex-start;
  }
`;

const JobCard = ({
  postedAt,
  company,
  link,
  country,
  title,
  location,
  role,
  positionType
}) => {
  const date = moment(postedAt).fromNow();
  return company ? (
    <Card>
      <DefaultContent href={link} target="__blank">
        <LeftColumn>
          <Logo
            src={company.logo.url ? company.logo.url : Startup}
            alt={`${company.name} Logo`}
          />
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              marginLeft: "2rem"
            }}
          >
            <JobTitle>{title}</JobTitle>
            <Subheading>{company.name}</Subheading>
          </div>
        </LeftColumn>
        <RightColumn>
          <Subheading>posted {date}</Subheading>
          <Subheading>
            {country} / {location}
          </Subheading>
          <Subheading>
            {role} / {positionType}
          </Subheading>
        </RightColumn>
      </DefaultContent>
    </Card>
  ) : null;
};

export default JobCard;



// WEBPACK FOOTER //
// ./src/components/Jobs/JobCard.js